
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/election2020/calendar",
      function () {
        return require("private-next-pages/election2020/calendar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/election2020/calendar"])
      });
    }
  